import classNames from 'classnames';
const FetchingIndicator = ({className}: {className?: string}) => (
  <div
    className={classNames('backdrop-filter backdrop-blur-lg backdrop-opacity-1 absolute h-full w-full z-10', className)}
  />
);

export default FetchingIndicator;
